module.exports = __webpack_public_path__ + "img/Notifications.524e1a68.jpg";